import React, { useState } from 'react'
import { useDiagram } from '../DiagramContext'
import { useComponentPinout, useComponentFullPinout } from '../../BlockDiagram'
import PinoutTable from './PinoutTable'
import {
  CONNECTOR_PART,
  useRelatedContentEnabledFor,
  useTools,
} from '../../hooks/RelatedContent'

const ConnectorFullPinout = ({ isAllPins, setIsAllPins, pageSize }) => {
  const diagram = useDiagram()
  const isRelatedContentEnabled =
    useRelatedContentEnabledFor(CONNECTOR_PART) &&
    diagram.blockDiagram.graph.selection === 'connector'
  const { isLoading, pinout } = useComponentFullPinout({
    vin: diagram.vin,
    componentId: diagram.blockDiagram.graph.data.componentId,
  })
  const { isLoading: toolsLoading, tools } = useTools({
    vin: diagram.vin,
    componentId: diagram.blockDiagram.graph.data.componentId,
    enabled: isRelatedContentEnabled,
  })
  return (
    <PinoutTable
      pinout={pinout}
      isLoading={isLoading}
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
      tools={tools}
      toolsLoading={toolsLoading}
      showTools={isRelatedContentEnabled}
    />
  )
}

const ConnectorSessionPinout = ({ isAllPins, setIsAllPins, pageSize }) => {
  const diagram = useDiagram()
  const isRelatedContentEnabled =
    useRelatedContentEnabledFor(CONNECTOR_PART) &&
    diagram.blockDiagram.graph.selection === 'connector'

  const { isLoading, pinout } = useComponentPinout({
    vin: diagram.vin,
    componentId: diagram.blockDiagram.graph.data.componentId,
    neighborIds: diagram.blockDiagram.graph.data.neighborIds,
  })
  const {
    isLoading: toolsLoading,
    isSuccess: toolsSuccess,
    tools,
  } = useTools({
    vin: diagram.vin,
    componentId: diagram.blockDiagram.graph.data.componentId,
    enabled: isRelatedContentEnabled,
  })
  return (
    <PinoutTable
      pinout={pinout}
      isLoading={isLoading}
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
      tools={tools}
      toolsLoading={toolsLoading}
      showTools={isRelatedContentEnabled}
    />
  )
}

const ConnectorPinout = ({ pageSize }) => {
  const [isAllPins, setIsAllPins] = useState(false)
  return isAllPins ? (
    <ConnectorFullPinout
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
    />
  ) : (
    <ConnectorSessionPinout
      isAllPins={isAllPins}
      setIsAllPins={setIsAllPins}
      pageSize={pageSize}
    />
  )
}

export default ConnectorPinout
